import { defineStore } from 'pinia'

import { computed, inject, ref } from 'vue'
import { VueCookies } from 'vue-cookies'

import { CREDENTIALS_COOKIE } from '../helpers/cookie'

export const useAccountStore = defineStore('account', () => {
	const $cookies = inject<VueCookies>('$cookies')

	// get account from cookies if exists to set as initial value
	let accountFromCookie = $cookies?.get(CREDENTIALS_COOKIE.key)
	if (accountFromCookie) {
		accountFromCookie = accountFromCookie as BarbanetCredentials
	}

	const credentials = ref<BarbanetCredentials | null>(accountFromCookie || null)
	const isLoggedIn = computed(() => !!credentials.value)

	const setCredentials = (data: BarbanetCredentials) => {
		credentials.value = data
		$cookies?.set(
			CREDENTIALS_COOKIE.key,
			data,
			CREDENTIALS_COOKIE.expires,
			CREDENTIALS_COOKIE.path,
			undefined,
			CREDENTIALS_COOKIE.secure,
			CREDENTIALS_COOKIE.sameSite
		)
	}

	return {
		credentials,
		isLoggedIn,
		setCredentials
	}
})
